/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Group_HelpInputs */

const en_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the group to copy timecodes to`)
};

const fr_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le groupe vers lequel copier les timecodes`)
};

const de_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Gruppe aus, in die die Timecodes kopiert werden sollen.`)
};

const it_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo in cui copiare i codici temporali`)
};

const ru_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу, в которую нужно скопировать временные метки.`)
};

const es_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el grupo al que desea copiar los códigos de tiempo`)
};

const zh_cn2_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要将时间码复制到的组`)
};

const ja_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードをコピーするグループを選択します`)
};

const hi_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड कॉपी करने के लिए समूह का चयन करें`)
};

const pt_pt2_target_group_help = /** @type {(inputs: Target_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o grupo para o qual deseja copiar os códigos de tempo.`)
};

/**
* | output |
* | --- |
* | "Select the group to copy timecodes to" |
*
* @param {Target_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_group_help = /** @type {((inputs?: Target_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_group_help(inputs)
	if (locale === "de") return de_target_group_help(inputs)
	if (locale === "it") return it_target_group_help(inputs)
	if (locale === "ru") return ru_target_group_help(inputs)
	if (locale === "es") return es_target_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_target_group_help(inputs)
	if (locale === "ja") return ja_target_group_help(inputs)
	if (locale === "hi") return hi_target_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_target_group_help(inputs)
	return en_target_group_help(inputs)
});